import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import "./Disclaimer.css";
import { Header } from "../Header-Assesment/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAssessmentId } from "../../../store/authSlice.js";
import LearnMore from "./LearnMore.pdf"
import api from "../../../axiosconfig.js";
import { toast } from "react-toastify";

export const DisclaimerTemplete = ({
  headerTitle,
  headerSubtitle,
  breadcrumbs,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleAgreeClick = async () => {
    try {
      setIsLoading(true);

      // Call backend to start a new assessment for the current authenticated user
      // The backend extracts userId from the JWT token via get_jwt_identity()
      const response = await api.post(`${API_URL}/api/assessments/start`, {});

      if (response.status === 201 && response.data?.assessmentId) {
        const newAssessmentId = response.data.assessmentId;
        // Save in Redux (which also syncs to localStorage safely)
        dispatch(setAssessmentId(newAssessmentId));

        toast.success("Assessment started! Let's begin.");
        navigate("/Assessment/maincontent/physical");
      } else {
        toast.error("Failed to start assessment. Please try again.");
      }
    } catch (error) {
      // Handle various error scenarios gracefully
      if (error.response?.status === 401) {
        toast.error("Session expired. Please login again.");
        navigate("/login");
      } else if (error.response?.status === 500) {
        toast.error("Server error. Please try again later.");
      } else {
        toast.error(
          error.response?.data?.error ||
          error.message ||
          "Unable to start assessment. Please check your connection and try again."
        );
      }
      console.error("Error starting assessment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="maincontent-Dis">
      <div className="header-assessment">
        <Header title={headerTitle} subtitle={headerSubtitle} />
      </div>
      <div className="toppart">
        <div className="breadcrumb">
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              {crumb.icon && (
                <FontAwesomeIcon
                  icon={crumb.icon}
                  style={{ color: "#c1c0bd" }}
                />
              )}
              <p className={crumb.active ? "element-text3" : "element-text"}>
                {crumb.text}
              </p>
              {i !== breadcrumbs.length - 1 && <p className="overline">/</p>}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="div-maindis">
        <div className="ass-dis">
          <div className="frame-110">
            <div className="frame-111">
              <div className="frame-112">
                <div className="frame-113">
                  <FontAwesomeIcon icon={faCircleExclamation} />
                  <span className="distext">Important Disclaimer</span>
                </div>
                <p className="para">
                  The mindsherpa PEARLI assessment is designed for informational
                  purposes only and your participation is anonymous. It does not
                  offer any diagnostic measurements or treatment advice and
                  should not be considered a substitute for professional mental
                  health care. This platform is supported by a volunteer base,
                  and while we strive for accuracy and helpfulness, the insights
                  provided are not a substitute for the expertise of qualified
                  mental health professionals. Always consult a licensed mental
                  health professional if you are going through a crisis or need
                  medical attention. Please be aware that due to the anonymous
                  and volunteer nature of this assessment, we cannot provide
                  individual follow-up or personalized support based on your
                  responses.
                </p>
              </div>
              <div className="frame-114">
                <a href={LearnMore} className="learn-more-dis">
                  <label>Learn More</label>
                </a>
                <button 
                  className="agree-dis" 
                  onClick={handleAgreeClick}
                  disabled={isLoading}
                >
                  <label>{isLoading ? "Starting..." : "I Agree"}</label>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
